<template>
  <div>
    <label>Billing</label>
    <div class="form-row">
      <div class="col">
        <select v-model="contract.billing.type"
                class="form-control text-capitalize form-control-sm"
                :disabled="disabled">
          <option class="text-capitalize"
                  v-for="(o, i) in summary.options(`billing`, `type`)"
                  :key="i">
            <span class="text-capitalize" v-text="o"></span>
          </option>
        </select>
        <small class="form-text text-muted">Billing Type</small>
      </div>
      <div class="col">
        <select v-model="contract.billing.schedule"
                class="form-control form-control-sm"
                :disabled="disabled">
          <option v-for="(o, i) in summary.options(`billing`, `schedule`)"
                  :key="i">
            <span v-text="o"></span>
          </option>
        </select>
        <small class="form-text text-muted">Billing Schedule</small>
      </div>
      <div class="col">
        <select v-model="contract.billing.values"
                class="form-control form-control-sm"
                :disabled="summary.disabled(`billing`, `values`)">
          <option v-for="(o, i) in summary.options(`billing`, `values`)"
                  :key="i">
            <span v-text="o"></span>
          </option>
        </select>
        <small class="form-text text-muted">Billing Values</small>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * The shared Billing form used by the contract create / amend / terminate
 * summary tabs. Type / schedule / values only — the off-cycle quarter cycle is
 * driven by the `"Quarterly 2"` schedule value and needs no extra control.
 */
export default {
  props: {
    /**
     * The contract being edited. Billing is read/written in place so it keeps
     * updating the parent's object.
     */
    contract: {
      type: Object,
      required: true,
    },
    /**
     * The parent's `summary` helper object, which provides the option lists.
     */
    summary: {
      type: Object,
      required: true,
    },
    /**
     * Locks the type/schedule selects (used when terminating a contract).
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
